<ul
  nz-menu
  nzMode="inline"
  nzTheme="light"
  nzTriggerSubMenuAction="click"
  [nzInlineCollapsed]="collapsed()"
  class="side-menu"
>
  @if (isAdmin()) {
    <li nz-menu-item [nzSelected]="isAdminFoodsMenuActive()" [nz-tooltip]="collapsed() ? ('nav.adminSystemFoods' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/foods">
        <svg lucideApple class="menu-icon"></svg>
        <span>{{ 'nav.adminSystemFoods' | translate }}</span>
      </a>
    </li>

    <li nz-menu-item [nzSelected]="isGroupReviewMenuActive()" [nz-tooltip]="collapsed() ? ('nav.adminGroupReview' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/foods/group-review">
        <svg lucideListChecks class="menu-icon"></svg>
        <span>{{ 'nav.adminGroupReview' | translate }}</span>
      </a>
    </li>

    <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.adminCatalogRequests' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/catalog-requests">
        <svg lucideClipboardList class="menu-icon"></svg>
        <span>{{ 'nav.adminCatalogRequests' | translate }}</span>
      </a>
    </li>

    @if (isStaging) {
      <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.adminRegistrationAllowlist' | translate) : null" nzTooltipPlacement="right">
        <a routerLink="/admin/system/registration-allowlist">
          <svg lucideMail class="menu-icon"></svg>
          <span>{{ 'nav.adminRegistrationAllowlist' | translate }}</span>
        </a>
      </li>
    }

    <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.adminSystemRecipes' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/recipes">
        <svg lucideBookOpen class="menu-icon"></svg>
        <span>{{ 'nav.adminSystemRecipes' | translate }}</span>
      </a>
    </li>

    <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.adminSystemUnits' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/units">
        <svg lucideRuler class="menu-icon"></svg>
        <span>{{ 'nav.adminSystemUnits' | translate }}</span>
      </a>
    </li>

    <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.adminSystemGroups' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/groups">
        <svg lucideGrid3X3 class="menu-icon"></svg>
        <span>{{ 'nav.adminSystemGroups' | translate }}</span>
      </a>
    </li>

    <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.adminSystemNutrientLists' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/admin/system/nutrient-lists">
        <svg lucideLayoutList class="menu-icon"></svg>
        <span>{{ 'nav.adminSystemNutrientLists' | translate }}</span>
      </a>
    </li>

    <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.settings' | translate) : null" nzTooltipPlacement="right">
      <a routerLink="/settings">
        <svg lucideSettings class="menu-icon"></svg>
        <span>{{ 'nav.settings' | translate }}</span>
      </a>
    </li>
  } @else {
  <li nz-menu-item nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.home' | translate) : null" nzTooltipPlacement="right">
    <a routerLink="/home">
      <svg lucideHouse class="menu-icon"></svg>
      <span>{{ 'nav.home' | translate }}</span>
    </a>
  </li>

  <li
    nz-submenu
    [nzTitle]="'nav.patients' | translate"
    nzIcon="team"
    nzTriggerSubMenuAction="click"
    [nzOpen]="openSubmenuKey() === 'patients'"
    (nzOpenChange)="onSubmenuOpenChange('patients', $event)"
    [nz-tooltip]="collapsed() ? ('nav.patients' | translate) : null"
    nzTooltipPlacement="right"
  >
    <ul>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/patients">
          <svg lucideLayoutList class="menu-icon"></svg>
          <span>{{ 'nav.patientsList' | translate }}</span>
        </a>
      </li>
      <li nz-menu-item nzMatchRouter>
        <a routerLink="/patients/create">
          <svg lucidePlus class="menu-icon"></svg>
          <span>{{ 'nav.createPatient' | translate }}</span>
        </a>
      </li>
    </ul>
  </li>

  <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.medicalRecords' | translate) : null" nzTooltipPlacement="right">
    <a routerLink="/medical-records">
      <svg lucideFileText class="menu-icon"></svg>
      <span>{{ 'nav.medicalRecords' | translate }}</span>
    </a>
  </li>

  <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.agenda' | translate) : null" nzTooltipPlacement="right">
    <a routerLink="/agenda">
      <svg lucideCalendar class="menu-icon"></svg>
      <span>{{ 'nav.agenda' | translate }}</span>
    </a>
  </li>

  <li
    nz-submenu
    [nzTitle]="'nav.foods' | translate"
    nzIcon="coffee"
    nzTriggerSubMenuAction="click"
    [nzOpen]="openSubmenuKey() === 'foods'"
    (nzOpenChange)="onSubmenuOpenChange('foods', $event)"
    [nz-tooltip]="collapsed() ? ('nav.foods' | translate) : null"
    nzTooltipPlacement="right"
  >
    <ul>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/foods/catalog">
          <svg lucideApple class="menu-icon"></svg>
          <span>{{ 'nav.foods' | translate }}</span>
        </a>
      </li>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/foods/recetas">
          <svg lucideBookOpen class="menu-icon"></svg>
          <span>{{ 'nav.recipes' | translate }}</span>
        </a>
      </li>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/foods/units">
          <svg lucideRuler class="menu-icon"></svg>
          <span>{{ 'nav.units' | translate }}</span>
        </a>
      </li>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/foods/groups">
          <svg lucideGrid3X3 class="menu-icon"></svg>
          <span>{{ 'nav.groups' | translate }}</span>
        </a>
      </li>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/foods/my-nutrients">
          <svg lucideLayoutList class="menu-icon"></svg>
          <span>{{ 'nav.myNutrients' | translate }}</span>
        </a>
      </li>
      <li nz-menu-item [nzMatchRouterExact]="true" nzMatchRouter>
        <a routerLink="/foods/nutrients">
          <svg lucideFlaskConical class="menu-icon"></svg>
          <span>{{ 'nav.nutrients' | translate }}</span>
        </a>
      </li>
    </ul>
  </li>

  <li nz-menu-item [nzMatchRouterExact]="false" nzMatchRouter [nz-tooltip]="collapsed() ? ('nav.dietTemplates' | translate) : null" nzTooltipPlacement="right">
    <a routerLink="/dietas">
      <svg lucidePill class="menu-icon"></svg>
      <span>{{ 'nav.dietTemplates' | translate }}</span>
    </a>
  </li>

  }
</ul>
